var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30336 20V6.50603H0.673173V20H5.30336ZM2.98887 4.66256C4.6035 4.66256 5.60852 3.62638 5.60852 2.3315C5.57844 1.00742 4.60356 0 3.01951 0C1.4357 0 0.399994 1.00744 0.399994 2.3315C0.399994 3.62644 1.40478 4.66256 2.95864 4.66256H2.98872H2.98887ZM7.86616 20H12.4964V12.4643C12.4964 12.061 12.5264 11.6581 12.6487 11.3698C12.9834 10.564 13.7453 9.72949 15.0243 9.72949C16.6998 9.72949 17.3701 10.9669 17.3701 12.7809V19.9999H22V12.2626C22 8.11777 19.7157 6.18923 16.6693 6.18923C14.1715 6.18923 13.0748 7.54167 12.4655 8.46281H12.4965V6.50575H7.86626C7.92703 7.77195 7.86626 19.9997 7.86626 19.9997L7.86616 20Z",
    fill: "#0D1117",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.cd03d3f92b834a3464bd99d71f8c1695.svg";
export { ForwardRef as ReactComponent };